import { get } from "../index"
import ChatRoutes from "./Chat.routes";

const ChatServices = {
  getAllChats: async (adId, userId, searchKey) => {
    const result = get(ChatRoutes.getChats + `?adId=${adId}&userId=${userId}&searchText=${searchKey}`);
    return result;
  },

  getAllMessages: async (adId, userId, chatId) => {
    const result = get(ChatRoutes.getMessages + `?adId=${adId}&userId=${userId}&chatId=${chatId}`);
    return result;
  }
};

export default ChatServices;